import {Component, OnInit, OnDestroy, ViewChild, HostListener, AfterViewInit, ApplicationRef, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';


@Component({
  selector   : 'app-card-layout',
  templateUrl: './card-page.component.html'

})
export class CardPageComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('sidemenu') sidemenu; // : MdSidenav;

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
  }


}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/layout/card-page.component.ts